import { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setDone(true);
    toast.success("You're on the list! Watch your inbox for spicy updates.");
    setEmail("");
    setTimeout(() => setDone(false), 4000);
  };

  return (
    <section
      data-testid="newsletter-section"
      className="relative py-24 md:py-32 bg-brand-mustard text-brand-charcoal overflow-hidden"
    >
      <div className="absolute top-0 right-0 font-display text-[14rem] md:text-[22rem] leading-none uppercase text-brand-charcoal/5 select-none pointer-events-none -mr-6 -mt-6">
        Spice
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-red">
            · Stay in the Loop
          </span>
          <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9]">
            Specials, events &<br />
            <span className="italic text-brand-red">exclusive offers.</span>
          </h2>
          <p className="mt-6 text-brand-charcoal/75 max-w-xl mx-auto">
            Be the first to hear about new menu drops, festival feasts, and
            members-only tasting nights at Red Chilly's.
          </p>

          <form
            onSubmit={submit}
            noValidate
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
          >
            <div className="relative flex-1">
              <Mail
                size={18}
                className="absolute left-5 top-1/2 -translate-y-1/2 text-brand-charcoal/40"
              />
              <input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="newsletter-email-input"
                className="w-full pl-12 pr-5 py-4 rounded-full bg-brand-cream border-2 border-brand-charcoal/10 focus:border-brand-red focus:outline-none focus:ring-4 focus:ring-brand-red/15 text-brand-charcoal placeholder:text-brand-charcoal/40 transition"
              />
            </div>
            <button
              type="submit"
              data-testid="newsletter-submit-button"
              className="px-8 py-4 rounded-full bg-brand-red text-brand-cream font-heading uppercase text-xs tracking-[0.2em] font-bold hover:bg-brand-deepred transition-all hover:-translate-y-1 shadow-xl inline-flex items-center justify-center gap-2"
            >
              {done ? (
                <>
                  <Check size={14} /> Subscribed
                </>
              ) : (
                "Subscribe"
              )}
            </button>
          </form>
          <p className="mt-4 text-xs text-brand-charcoal/55">
            No spam. Unsubscribe anytime. Just good food news.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
